import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ChangeEvent, useState } from 'react';
import { Button } from 'react-bootstrap';
import { faImage, faXmark } from '@fortawesome/free-solid-svg-icons';
import { getSasTokenAsync } from 'data/storage';
import { Project } from 'data/projects';
import { BlobServiceClient } from '@azure/storage-blob';
import projectService from 'services/project';

const CoverImage = ({
  project,
  handleClose
}: {
  project: Project;
  handleClose: () => void;
}) => {
  const [image, setImage] = useState<File | null>(null);

  const handleChange = async (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && project) {
      const updateProject = { ...project };
      try {
        const sasToken = await getSasTokenAsync();

        const storageAccountName = 'nupitchstorage';
        const containerName = 'nupitch-test-blob-container';

        const blobServiceClient = new BlobServiceClient(
          `https://${storageAccountName}.blob.core.windows.net${sasToken}`
        );
        const containerClient =
          blobServiceClient.getContainerClient(containerName);

        const originalFileName = e.target.files[0].name;
        const fileExtension = originalFileName.split('.').pop(); // Extract the file extension
        const newFileName = `nupitch_${updateProject.projectId}_1_project_img.${fileExtension}`; // Append the file extension to the new filename

        const file = e.target.files[0];

        // Create a new BlockBlobClient with the new file name
        const blockBlobClient = containerClient.getBlockBlobClient(newFileName);

        // Upload the file
        await blockBlobClient.uploadData(file);

        // Get the base URL without the SAS token
        const blobUrl = blockBlobClient.url.split('?')[0];

        // Update the member's avatar with the blob URL
        updateProject.image = blobUrl;
        projectService.editProject(updateProject).then(data => {
          if (data) {
            console.log('Project backgound image changed successfully');
          } else {
            console.error('Error:', 'problem editing project ' + project.title);
          }
        });
      } catch (error) {
        console.error('Error uploading image:', error);
      }
      // if (onChange) {
      //   onChange(updateProject); // Pass the updated member object to the onChange handler
      // }

      setImage(e.target.files[0] || null);
    }
  };
  return (
    <>
      <input
        type="file"
        id="projectCoverInput"
        className="d-none"
        onChange={handleChange}
      />
      <label
        className="position-absolute top-0 start-0"
        htmlFor="projectCoverInput"
      >
        <span className="project-modal-btn d-inline-block bg-white dark__text-white rounded-2 py-2 px-3 fs-9 fw-bolder mt-3 ms-3 cursor-pointer">
          <FontAwesomeIcon icon={faImage} className="me-1" />
          Change Image
        </span>
      </label>

      <Button
        variant="circle"
        className="project-modal-btn position-absolute end-0 top-0 mt-3 me-3 bg-white"
        onClick={handleClose}
      >
        <FontAwesomeIcon icon={faXmark} />
      </Button>
      <img
        src={image ? URL.createObjectURL(image) : project.image}
        alt="cover"
        className="w-100"
        style={{ minHeight: 150, maxHeight: 280 }}
      />
    </>
  );
};

export default CoverImage;
